export const applyRouter = [
  {
    path: 'org2',
    meta: {
      title: '认证培训机构',
    },
    component: () => import('../views/apply/page/org2'),
  },
  {
    path: 'org3',
    meta: {
      title: '实习基地',
    },
    component: () => import('../views/apply/page/org3'),
  },
  {
    path: 'org4',
    meta: {
      title: '考场',
    },
    component: () => import('../views/apply/page/org4'),
  },
  {
    path: 'org5',
    meta: {
      title: '产教融合基地',
    },
    component: () => import('../views/apply/page/org5'),
  },
  {
    path: 'org6',
    meta: {
      title: '协调中心',
    },
    component: () => import('../views/apply/page/org6'),
  }
]